/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AttendancePhotoNoticeSeenRequest } from '../models/AttendancePhotoNoticeSeenRequest';
import type { AttendanceSettlementExceptionRequest } from '../models/AttendanceSettlementExceptionRequest';
import type { AttendanceSettlementGenerateRequest } from '../models/AttendanceSettlementGenerateRequest';
import type { AttendanceSettlementPaymentTraceRequest } from '../models/AttendanceSettlementPaymentTraceRequest';
import type { AttendanceSettlementReopenDecision } from '../models/AttendanceSettlementReopenDecision';
import type { AttendanceSettlementReopenRequest } from '../models/AttendanceSettlementReopenRequest';
import type { AttendanceSettlementVersionRequest } from '../models/AttendanceSettlementVersionRequest';
import type { Body_upload_punch_photo_endpoint_api_v1_attendance_punches__punch_id__photo_post } from '../models/Body_upload_punch_photo_endpoint_api_v1_attendance_punches__punch_id__photo_post';
import type { FieldPunchPreflightRequest } from '../models/FieldPunchPreflightRequest';
import type { PunchRequest } from '../models/PunchRequest';
import type { SuccessResponse_AttendanceMonthlySummaryResponse_ } from '../models/SuccessResponse_AttendanceMonthlySummaryResponse_';
import type { SuccessResponse_AttendancePhotoNoticeStatus_ } from '../models/SuccessResponse_AttendancePhotoNoticeStatus_';
import type { SuccessResponse_AttendancePunchPhotoResponse_ } from '../models/SuccessResponse_AttendancePunchPhotoResponse_';
import type { SuccessResponse_AttendancePunchPhotoTimelineResponse_ } from '../models/SuccessResponse_AttendancePunchPhotoTimelineResponse_';
import type { SuccessResponse_AttendanceSelfWorktimeResponse_ } from '../models/SuccessResponse_AttendanceSelfWorktimeResponse_';
import type { SuccessResponse_AttendanceSettlementDetail_ } from '../models/SuccessResponse_AttendanceSettlementDetail_';
import type { SuccessResponse_AttendanceSettlementListResponse_ } from '../models/SuccessResponse_AttendanceSettlementListResponse_';
import type { SuccessResponse_AttendanceStoreWorktimeSummaryResponse_ } from '../models/SuccessResponse_AttendanceStoreWorktimeSummaryResponse_';
import type { SuccessResponse_AttendanceTodayResponse_ } from '../models/SuccessResponse_AttendanceTodayResponse_';
import type { SuccessResponse_CalendarResponse_ } from '../models/SuccessResponse_CalendarResponse_';
import type { SuccessResponse_DailyAttendanceResponse_ } from '../models/SuccessResponse_DailyAttendanceResponse_';
import type { SuccessResponse_FieldPunchNoticeDetailResponse_ } from '../models/SuccessResponse_FieldPunchNoticeDetailResponse_';
import type { SuccessResponse_FieldPunchPreflightResponse_ } from '../models/SuccessResponse_FieldPunchPreflightResponse_';
import type { SuccessResponse_FieldPunchSupportStoresResponse_ } from '../models/SuccessResponse_FieldPunchSupportStoresResponse_';
import type { SuccessResponse_FieldPunchTraceResponse_ } from '../models/SuccessResponse_FieldPunchTraceResponse_';
import type { SuccessResponse_PunchResponse_ } from '../models/SuccessResponse_PunchResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AttendanceService {
    /**
     * List Attendance Settlements Endpoint
     * @returns SuccessResponse_AttendanceSettlementListResponse_ Successful Response
     * @throws ApiError
     */
    public static listAttendanceSettlementsEndpointApiV1AttendanceSettlementsGet({
        periodMonth,
    }: {
        periodMonth: string,
    }): CancelablePromise<SuccessResponse_AttendanceSettlementListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/attendance/settlements',
            query: {
                'period_month': periodMonth,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Generate Attendance Settlement Endpoint
     * @returns SuccessResponse_AttendanceSettlementDetail_ Successful Response
     * @throws ApiError
     */
    public static generateAttendanceSettlementEndpointApiV1AttendanceSettlementsGeneratePost({
        requestBody,
    }: {
        requestBody: AttendanceSettlementGenerateRequest,
    }): CancelablePromise<SuccessResponse_AttendanceSettlementDetail_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/attendance/settlements/generate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Attendance Settlement Endpoint
     * @returns SuccessResponse_AttendanceSettlementDetail_ Successful Response
     * @throws ApiError
     */
    public static getAttendanceSettlementEndpointApiV1AttendanceSettlementsSettlementIdGet({
        settlementId,
    }: {
        settlementId: number,
    }): CancelablePromise<SuccessResponse_AttendanceSettlementDetail_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/attendance/settlements/{settlement_id}',
            path: {
                'settlement_id': settlementId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Attendance Settlement Exception Endpoint
     * @returns SuccessResponse_AttendanceSettlementDetail_ Successful Response
     * @throws ApiError
     */
    public static addAttendanceSettlementExceptionEndpointApiV1AttendanceSettlementsSettlementIdExceptionsPost({
        settlementId,
        requestBody,
    }: {
        settlementId: number,
        requestBody: AttendanceSettlementExceptionRequest,
    }): CancelablePromise<SuccessResponse_AttendanceSettlementDetail_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/attendance/settlements/{settlement_id}/exceptions',
            path: {
                'settlement_id': settlementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Confirm Attendance Settlement Endpoint
     * @returns SuccessResponse_AttendanceSettlementDetail_ Successful Response
     * @throws ApiError
     */
    public static confirmAttendanceSettlementEndpointApiV1AttendanceSettlementsSettlementIdManagerConfirmPost({
        settlementId,
        requestBody,
    }: {
        settlementId: number,
        requestBody: AttendanceSettlementVersionRequest,
    }): CancelablePromise<SuccessResponse_AttendanceSettlementDetail_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/attendance/settlements/{settlement_id}/manager-confirm',
            path: {
                'settlement_id': settlementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Lock Attendance Settlement Endpoint
     * @returns SuccessResponse_AttendanceSettlementDetail_ Successful Response
     * @throws ApiError
     */
    public static lockAttendanceSettlementEndpointApiV1AttendanceSettlementsSettlementIdFinanceLockPost({
        settlementId,
        requestBody,
    }: {
        settlementId: number,
        requestBody: AttendanceSettlementVersionRequest,
    }): CancelablePromise<SuccessResponse_AttendanceSettlementDetail_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/attendance/settlements/{settlement_id}/finance-lock',
            path: {
                'settlement_id': settlementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Request Attendance Settlement Reopen Endpoint
     * @returns SuccessResponse_AttendanceSettlementDetail_ Successful Response
     * @throws ApiError
     */
    public static requestAttendanceSettlementReopenEndpointApiV1AttendanceSettlementsSettlementIdReopenRequestsPost({
        settlementId,
        requestBody,
    }: {
        settlementId: number,
        requestBody: AttendanceSettlementReopenRequest,
    }): CancelablePromise<SuccessResponse_AttendanceSettlementDetail_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/attendance/settlements/{settlement_id}/reopen-requests',
            path: {
                'settlement_id': settlementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Decide Attendance Settlement Reopen Endpoint
     * @returns SuccessResponse_AttendanceSettlementDetail_ Successful Response
     * @throws ApiError
     */
    public static decideAttendanceSettlementReopenEndpointApiV1AttendanceSettlementReopensReopenIdDecisionPost({
        reopenId,
        requestBody,
    }: {
        reopenId: number,
        requestBody: AttendanceSettlementReopenDecision,
    }): CancelablePromise<SuccessResponse_AttendanceSettlementDetail_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/attendance/settlement-reopens/{reopen_id}/decision',
            path: {
                'reopen_id': reopenId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Record Attendance Settlement Payment Trace Endpoint
     * @returns SuccessResponse_AttendanceSettlementDetail_ Successful Response
     * @throws ApiError
     */
    public static recordAttendanceSettlementPaymentTraceEndpointApiV1AttendanceSettlementsSettlementIdPaymentTracesPost({
        settlementId,
        requestBody,
    }: {
        settlementId: number,
        requestBody: AttendanceSettlementPaymentTraceRequest,
    }): CancelablePromise<SuccessResponse_AttendanceSettlementDetail_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/attendance/settlements/{settlement_id}/payment-traces',
            path: {
                'settlement_id': settlementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Attendance Settlement Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static exportAttendanceSettlementEndpointApiV1AttendanceSettlementsSettlementIdExportGet({
        settlementId,
    }: {
        settlementId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/attendance/settlements/{settlement_id}/export',
            path: {
                'settlement_id': settlementId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Attendance Schedule Endpoint
     * GET /api/v1/attendance/schedule-export — 考勤月报 xlsx.
     * @returns binary 考勤月报 xlsx; X-Ember-Fact-Count 为底层事实条数
     * @throws ApiError
     */
    public static exportAttendanceScheduleEndpointApiV1AttendanceScheduleExportGet({
        year,
        month,
        brand = 'all',
        storeId,
    }: {
        year: number,
        month: number,
        brand?: 'all' | 'yss' | 'qjx',
        storeId?: (number | null),
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/attendance/schedule-export',
            query: {
                'year': year,
                'month': month,
                'brand': brand,
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Punch Endpoint
     * POST /api/v1/attendance/punch — GPS 打卡 (D6 yes §0.5 #3).
     * @returns SuccessResponse_PunchResponse_ Successful Response
     * @throws ApiError
     */
    public static punchEndpointApiV1AttendancePunchPost({
        requestBody,
        xEmberPunchPhotoScope,
        xEmberInstallationCredential,
    }: {
        requestBody: PunchRequest,
        xEmberPunchPhotoScope?: (string | null),
        xEmberInstallationCredential?: (string | null),
    }): CancelablePromise<SuccessResponse_PunchResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/attendance/punch',
            headers: {
                'X-Ember-Punch-Photo-Scope': xEmberPunchPhotoScope,
                'X-Ember-Installation-Credential': xEmberInstallationCredential,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Photo Notice Status Endpoint
     * @returns SuccessResponse_AttendancePhotoNoticeStatus_ Successful Response
     * @throws ApiError
     */
    public static photoNoticeStatusEndpointApiV1AttendancePhotoNoticeGet(): CancelablePromise<SuccessResponse_AttendancePhotoNoticeStatus_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/attendance/photo-notice',
        });
    }
    /**
     * Photo Notice Seen Endpoint
     * @returns SuccessResponse_AttendancePhotoNoticeStatus_ Successful Response
     * @throws ApiError
     */
    public static photoNoticeSeenEndpointApiV1AttendancePhotoNoticeSeenPost({
        requestBody,
    }: {
        requestBody: AttendancePhotoNoticeSeenRequest,
    }): CancelablePromise<SuccessResponse_AttendancePhotoNoticeStatus_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/attendance/photo-notice/seen',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Punch Photo Endpoint
     * @returns SuccessResponse_AttendancePunchPhotoResponse_ Successful Response
     * @throws ApiError
     */
    public static uploadPunchPhotoEndpointApiV1AttendancePunchesPunchIdPhotoPost({
        punchId,
        formData,
    }: {
        punchId: number,
        formData: Body_upload_punch_photo_endpoint_api_v1_attendance_punches__punch_id__photo_post,
    }): CancelablePromise<SuccessResponse_AttendancePunchPhotoResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/attendance/punches/{punch_id}/photo',
            path: {
                'punch_id': punchId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Punch Photo Content Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static punchPhotoContentEndpointApiV1AttendancePunchPhotosPhotoIdContentGet({
        photoId,
    }: {
        photoId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/attendance/punch-photos/{photo_id}/content',
            path: {
                'photo_id': photoId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Employee Punch Photo Timeline Endpoint
     * @returns SuccessResponse_AttendancePunchPhotoTimelineResponse_ Successful Response
     * @throws ApiError
     */
    public static employeePunchPhotoTimelineEndpointApiV1AttendanceEmployeesEmployeeIdPunchPhotosGet({
        employeeId,
        dateFrom,
        dateTo,
    }: {
        employeeId: number,
        dateFrom?: (string | null),
        dateTo?: (string | null),
    }): CancelablePromise<SuccessResponse_AttendancePunchPhotoTimelineResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/attendance/employees/{employee_id}/punch-photos',
            path: {
                'employee_id': employeeId,
            },
            query: {
                'date_from': dateFrom,
                'date_to': dateTo,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Field Punch Support Stores Endpoint
     * @returns SuccessResponse_FieldPunchSupportStoresResponse_ Successful Response
     * @throws ApiError
     */
    public static fieldPunchSupportStoresEndpointApiV1AttendanceFieldPunchSupportStoresGet(): CancelablePromise<SuccessResponse_FieldPunchSupportStoresResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/attendance/field-punch/support-stores',
        });
    }
    /**
     * Field Punch Preflight Endpoint
     * @returns SuccessResponse_FieldPunchPreflightResponse_ Successful Response
     * @throws ApiError
     */
    public static fieldPunchPreflightEndpointApiV1AttendanceFieldPunchPreflightPost({
        requestBody,
        xEmberPunchPhotoScope,
    }: {
        requestBody: FieldPunchPreflightRequest,
        xEmberPunchPhotoScope?: (string | null),
    }): CancelablePromise<SuccessResponse_FieldPunchPreflightResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/attendance/field-punch/preflight',
            headers: {
                'X-Ember-Punch-Photo-Scope': xEmberPunchPhotoScope,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Field Punch Trace Endpoint
     * @returns SuccessResponse_FieldPunchTraceResponse_ Successful Response
     * @throws ApiError
     */
    public static fieldPunchTraceEndpointApiV1AttendanceFieldNoticesRecentGet({
        days = 30,
    }: {
        days?: number,
    }): CancelablePromise<SuccessResponse_FieldPunchTraceResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/attendance/field-notices/recent',
            query: {
                'days': days,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Field Punch Notice Detail Endpoint
     * @returns SuccessResponse_FieldPunchNoticeDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static fieldPunchNoticeDetailEndpointApiV1AttendanceFieldNoticesEmployeeIdWorkDateGet({
        employeeId,
        workDate,
        storeId,
    }: {
        employeeId: number,
        workDate: string,
        storeId?: (number | null),
    }): CancelablePromise<SuccessResponse_FieldPunchNoticeDetailResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/attendance/field-notices/{employee_id}/{work_date}',
            path: {
                'employee_id': employeeId,
                'work_date': workDate,
            },
            query: {
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Today Endpoint
     * GET /api/v1/attendance/me/today — 今日打卡状态.
     * @returns SuccessResponse_AttendanceTodayResponse_ Successful Response
     * @throws ApiError
     */
    public static getTodayEndpointApiV1AttendanceMeTodayGet({
        xEmberPunchPhotoScope,
    }: {
        xEmberPunchPhotoScope?: (string | null),
    }): CancelablePromise<SuccessResponse_AttendanceTodayResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/attendance/me/today',
            headers: {
                'X-Ember-Punch-Photo-Scope': xEmberPunchPhotoScope,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Calendar Endpoint
     * GET /api/v1/attendance/me/calendar — 员工月历考勤视图 (only-read, D6 exempt).
     * @returns SuccessResponse_CalendarResponse_ Successful Response
     * @throws ApiError
     */
    public static getCalendarEndpointApiV1AttendanceMeCalendarGet({
        year,
        month,
    }: {
        year?: (number | null),
        month?: (number | null),
    }): CancelablePromise<SuccessResponse_CalendarResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/attendance/me/calendar',
            query: {
                'year': year,
                'month': month,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Monthly Summary Endpoint
     * GET /api/v1/attendance/me/monthly-summary — 员工月度考勤汇总 (only-read).
     * @returns SuccessResponse_AttendanceMonthlySummaryResponse_ Successful Response
     * @throws ApiError
     */
    public static getMonthlySummaryEndpointApiV1AttendanceMeMonthlySummaryGet({
        year,
        month,
    }: {
        year?: (number | null),
        month?: (number | null),
    }): CancelablePromise<SuccessResponse_AttendanceMonthlySummaryResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/attendance/me/monthly-summary',
            query: {
                'year': year,
                'month': month,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Self Worktime Endpoint
     * GET /api/v1/attendance/me/worktime — 员工本人月工时 (only-read).
     * @returns SuccessResponse_AttendanceSelfWorktimeResponse_ Successful Response
     * @throws ApiError
     */
    public static getSelfWorktimeEndpointApiV1AttendanceMeWorktimeGet({
        year,
        month,
    }: {
        year?: (number | null),
        month?: (number | null),
    }): CancelablePromise<SuccessResponse_AttendanceSelfWorktimeResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/attendance/me/worktime',
            query: {
                'year': year,
                'month': month,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Daily Attendance Endpoint
     * GET /api/v1/stores/{store_id}/attendance/daily — 查看门店当日打卡明细.
     * @returns SuccessResponse_DailyAttendanceResponse_ Successful Response
     * @throws ApiError
     */
    public static getDailyAttendanceEndpointApiV1StoresStoreIdAttendanceDailyGet({
        storeId,
        date,
    }: {
        storeId: number,
        date?: string,
    }): CancelablePromise<SuccessResponse_DailyAttendanceResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/stores/{store_id}/attendance/daily',
            path: {
                'store_id': storeId,
            },
            query: {
                'date': date,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Store Worktime Summary Endpoint
     * GET /api/v1/stores/{store_id}/attendance/worktime-summary — 门店月工时汇总.
     * @returns SuccessResponse_AttendanceStoreWorktimeSummaryResponse_ Successful Response
     * @throws ApiError
     */
    public static getStoreWorktimeSummaryEndpointApiV1StoresStoreIdAttendanceWorktimeSummaryGet({
        storeId,
        year,
        month,
    }: {
        storeId: number,
        year?: (number | null),
        month?: (number | null),
    }): CancelablePromise<SuccessResponse_AttendanceStoreWorktimeSummaryResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/stores/{store_id}/attendance/worktime-summary',
            path: {
                'store_id': storeId,
            },
            query: {
                'year': year,
                'month': month,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
